import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

import Input from "app/pages/activation/components/Input/Input";

const { carbon, blue } = colorsPalettes;

export const Title = styled.div`
    padding: 20px 24px;
    ${setFontVariant("h5_2", carbon[500])};
`;

export const Content = styled(FlexColumn)<{ step: "initial" | "name" }>`
    padding: ${({ step }) => (step === "initial" ? "16px 64px 24px 24px" : "16px 24px 24px")};
    ${setFontVariant("body1", carbon[400])};
    gap: 24px;

    & > p {
        margin: 0;
    }
`;

export const Footer = styled(FlexRow)`
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    padding: 8px 16px 16px;
`;

export const DescriptionWithDD = styled(FlexRow)`
    position: relative;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;

    .ItemIcon {
        flex-shrink: 0;
    }
`;

export const InputContainer = styled(FlexColumn)<{ isError?: boolean }>`
    gap: 8px;

    margin-bottom: ${({ isError = false }) => (isError ? "24px" : "0")};
`;

export const InputLabel = styled.label`
    ${setFontVariant("subtitle1", carbon[400])}
`;

export const StyledInput = styled(Input)`
    input {
        box-shadow: unset;
    }
`;

export const TooltipLink = styled.a`
    display: block;
    ${setFontVariant("tooltip", blue[300])};
`;
